export default class TroopMovementType {
    static incomingAttack = 'incomingAttack'
    static incomingRaid = 'incomingRaid'
    static incomingSiege = 'incomingSiege'
    static incomingReinforcement = 'incomingReinforcement'
    static incomingForwarding = 'incomingForwarding'
    static incomingReturn = 'incomingReturn'

    static outgoingAttack = 'outgoingAttack'
    static outgoingRaid = 'outgoingRaid'
    static outgoingSiege = 'outgoingSiege'
    static outgoingReinforcement = 'outgoingReinforcement'
    static outgoingForwarding = 'outgoingForwarding'
    static outgoingReturn = 'outgoingReturn'

    static stationary = 'stationary'

    static isIncoming(type) {
        return type.indexOf('incoming') === 0;
    }

    static isOutgoing(type) {
        return type.indexOf('outgoing') === 0;
    }

    static isStationary(type) {
        return type === this.stationary;
    }

    static isHostileIncoming(type) {
        return type === this.incomingAttack || type === this.incomingRaid || type === this.incomingSiege;
    }
}
